import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { SquirrelTabs, USERTABS } from 'shared';
import { UserDto, UserResolved } from 'shared';
import { UserProfileForCreation } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { UserProfileService } from 'shared';
import { Observable } from 'rxjs';

@Component({
    selector: 'edit-user-profile',
    templateUrl: './edit-user-profile.component.html',
    styleUrls: ['./edit-user-profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditUserProfileComponent implements OnInit {
  userDto!: UserDto;
  tabs: SquirrelTabs[] = [];

  //admin$!: Observable<string>;
  admin!: string;
  showTenantGrpRoles: boolean = true;
  showProjects: boolean = true;
  assignedTenant: string = '';

  constructor(private route: ActivatedRoute,
    private oauthService: OAuthServiceService,
    private tenantService: TenantService,
    private userProfileService: UserProfileService,
    private notificationService: NotificationService,
    public translate: TranslateService) { }

  ngOnInit(): void {
    this.assignedTenant = this.tenantService.tempTenantName;
    // es kann sein, dass diese Aktion vom Admin in SM ausgeführt wird, dann ist der temporäre Tenant ungleich dem current Tenant
    // in diesem Fall sollen die Projekte & Berechtigungen nicht angezeigt werden
    this.showProjects = this.tenantService.currentTenantName == this.tenantService.tempTenantName; 
    //this.showTenantGrpRoles = this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation;
    this.tabs = USERTABS;
    this.route.data.subscribe((data: any) => {
      const resolvedData: UserResolved = data['resolvedData'];
      console.log("edit-user-profile: resolvedData = ", resolvedData);
      if (resolvedData.error) {
        console.error("edit-user-profile: Error retrieving user data: ", resolvedData.error);
        this.notificationService.warning("Edit User Profile", "Benutzer existiert nicht mehr!");
      } else {
        this.userDto = resolvedData.userDto;

        console.log("edit-user-profile: ============== getUserById =============")
        this.userProfileService.getUserById(this.userDto.id).subscribe({
          next:(userProfile: UserProfileForCreation) => {       
            //(userProfile.fullName) ? this.userDto.userName = userProfile.fullName : this.userDto.userName = userProfile.username;
            if (userProfile.familyName != null)
              this.userDto.userName = userProfile.givenName + " " + userProfile.familyName;
            this.userDto.first_Name = userProfile.givenName;
            this.userDto.last_Name = userProfile.familyName;
            this.userDto.phoneNumber = userProfile.phoneNumber;
            }
        });
      }

    },
      // error
    );

    this.oauthService.userData.subscribe({
      next: (data) => {
        (data as any).role.forEach((r: string) => {
          if (r === 'admin') {
            this.admin = r;
          }
        });
      }
    });
  }
}
